module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAaCAMAAADG6y/lAAAANlBMVEVHcEyFRRqERRqERhqNTSSFRhqFRRqFRRqFRxuKSCCGRx2FRRqGRxuERRqERRqbViSPTR6ISBuJGkEPAAAADnRSTlMAlabpC33a9mUaQs0vvuWgSpgAAADsSURBVDjLlZRZEoQgDERDWJKgot7/sqM4MyjE7X1ZlW6WThAAwAcK2MMlPS4inz+lSxmUc7ngpulWzVefEpkTixj6aToATgXyrpU7TzsJlw0yliuLY3sQdEDpSNhbHIeqTGBTDWHMl5GI1BQtYNKgEEgtIPR64QRa2uXfGHLrzHO92bIwL/WPT+VL3vxEz/uGxl9W8zRNej6xGt+tgfO4olhsM/4SiqF1BGWQ3bBWRtUxOG3sHZYtxuM8uJOHZYpj1uJv4ZxTdSS+euuc490vT3z9d4jV+7ARbpDhEI/APfFvGSI8Q9gb41ld/QPOtCenwa4aPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/brown-row.png
// module id = 605
// module chunks = 1